import React from 'react';
import _ from 'lodash';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';
import { ColorPicker } from '@/workbook/ColorPicker.organism';
import { getFormFieldProps, getValidationFunction, canUseMemo } from '@/formbuilder/formbuilder.utilities';
import { Field, useForm } from 'react-final-form';

export interface ColorPickerIF extends ValidatingFormComponent<string> {
  component: 'ColorPickerFormComponent';
  placement: string;
  color: string;
  colors: string[];
  itemId: number;
  notifyOnSelect?: (itemId: number, color: string) => void;
  dataTestId?: string;
}

const ColorPickerFormComponentUnwrapped: React.FunctionComponent<ColorPickerIF> = (props) => {
  const { name, validation, extendValidation, extraClassNames } = props;

  const defaultValidation = (value: string | undefined) => _.isEmpty(value);
  const formState = useForm().getState();

  return (
    <Field name={name} validate={getValidationFunction(defaultValidation, extendValidation, validation)}>
      {({ input, meta }) => (
        <div className={extraClassNames}>
          <ColorPicker {...getFormFieldProps(formState, input, meta, props)} />
        </div>
      )}
    </Field>
  );
};

export const ColorPickerFormComponent = React.memo(ColorPickerFormComponentUnwrapped, canUseMemo);
